import {
    DEFAULT_AGENT_PERMISSIONS,
    DEFAULT_AGENTS_COUNT,
    DEFAULT_AGENTS_FILTERS,
    DEFAULT_PAGE_INDEX,
    DEFAULT_PAGE_SIZE,
} from "../agents.constants";
import { initialAgentDetailState } from "./agentDetail/agentDetailState";
import { AgentsState } from "./agentsTypes";

export const initialAgentsState: AgentsState = {
    hasLoadedAgents: false,
    agentsDetails: [],
    agentsCountWithSegregation: DEFAULT_AGENTS_COUNT,
    agentPermissions: DEFAULT_AGENT_PERMISSIONS,
    availableFilters: [],

    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
    searchParam: null,
    filters: DEFAULT_AGENTS_FILTERS,
    sortRequest: null,

    isAgentsLoading: false,
    agentsError: null,

    detail: initialAgentDetailState,
    allStates: null,
    allStatesLoading: false,

    agenciesList: null,
    agentsList: null,
    userTypesList: null,
    filterListsLoading: false,
};
